module.exports = __webpack_public_path__ + "img/1_1-parco-0.ce103a14.png";